module.exports = __webpack_public_path__ + "static/media/BulkReturn2.182cdbf6.png";